import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Images from "../../constants/images";
import { useEffect, useState } from "react";
import url from "../../config/axios";
import "./style.css";
import { getAsset } from "../../helpers/helper";
import Reportreplymodal from "../Report_replymodal";
import { useLocation } from "react-router-dom";
const Reportmodal = ({ setOpenBox, reportM,shopid,setHide }) => {
  const location = useLocation();
  const [report, setReport] = useState();
  const [replyshow, setReplyshow] = useState(false);

  const handleClosereport = () => setReplyshow(false);
  const handleShowreport = () => setReplyshow(true);
 
  useEffect(() => {
    const endpoint =
      location.pathname === `/service-report/${shopid}`
        ? `reportservice/getInnerReportById/?serviceId=${shopid}&reportId=${reportM}`
        : `reportshop/getInnerReportById/?shopId=${shopid}&reportId=${reportM}`;

    url.get(endpoint)
      .then((res) => {
        setReport(res?.data?.report);
      })
      .catch((error) => {
        console.error("Error fetching report:", error);
      });
  }, [shopid, reportM, location.pathname, setReport]);


  return (
    <div>
      <Reportreplymodal replyshow={replyshow} handleClosereport={handleClosereport} shopid={shopid} reportM={reportM} />
      <Container className="">
        <div>
          <div>
            <Modal.Header
              className="report-bttn"
              closeButton
              onClick={() => {
                setOpenBox(1); setHide(true);
              }}
            >
              <Modal.Title className="ms-3">Report</Modal.Title>
            </Modal.Header>
            <hr />
            <div className="report-hgt noscroll">
              <div>
                <h6 className="report-bug ms-3 p-2">{report?.reportType}</h6>
              </div>
              <h6 className="mt-4 ms-3">Report Description*</h6>
              <div>
                <p className="text-0 ms-3 font_sm_14 p-2">
                  {report?.description}
                </p>
              </div>
              <h6 className="mt-4 mb-3 ms-3">Screenshots*</h6>
              {report?.image[0]?.length > 0 ? (
                <Row className="m-0">
                  {report?.image?.map((e) => (
                    <Col lg={4}>
                      <img
                        className="report-image"
                        src={getAsset(e)}
                        crossOrigin="anonymous"
                      />
                    </Col>
                  ))}
                </Row>
              ) : 
              
              (
                <h6 className="text-center">No Images Found</h6>
              )

              }

              <div className="d-flex justify-content-end mt-3 me-2">
                <button className="text-white bg-primary btn pt-0 pb-0" onClick={handleShowreport}>
                  Reply
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default Reportmodal;
